import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomAIFilled = createSvgIcon(
  <path d="M21.1 3c.5 0 .9.4.9.9v16.2c0 .5-.4.9-.9.9H2.9c-.5 0-.9-.5-.9-.9V7.4c0-.5.3-1.2.7-1.5l2.6-2.2c.4-.4 1.1-.7 1.6-.7zM10.9 7.7H8.7c-.3 0-.5.1-.6.4l-3.3 9v.1c0 .1 0 .1.1.2s.1.1.2.1h1.8c.2 0 .4-.1.5-.3l.5-1.4h3.6l.5 1.4c.1.2.3.3.5.3h1.8c.1 0 .1 0 .2-.1s.1-.1.3-.2v-.1l-3.3-9c-.1-.3-.3-.4-.6-.4m7.1-.1h-2s-.1 0-.2.1-.1.2-.1.3v9.2s0 .1.1.2c0 .1.1.1.2.1h2.1c.1 0 .1 0 .2-.1.1 0 .1-.1.1-.2V7.9c0-.1 0-.1-.1-.2s-.2-.1-.3-.1m-8.3 2.6 1.2 3.5H8.5z" />,
  'CustomAIFilled',
);

export default CustomAIFilled;
